export class CustomerInstanceFeaturesData {
    id: string;

    biEnabled: boolean;
    syncEnabled: boolean;
    groupAccessEnabled: boolean;
    managementMode: boolean;
    autoRegisterDevices: boolean;
    useAutomaticPaymentCapture: boolean;
    serviceFeeNameOverride: string;
}

export class CustomerInstanceData {
    public static readonly DEPLOYMENT_STATUS_CHEWZIE = "CHEWZIE";

    id: string;

    clientId: string;

    /**
     * Optional reference to a group pk (not groupId)
     */
    instanceGroupId: string;

    /**
     * Optional subgroup to limit sync scope to instances with similar configurations
     */
    brand: string;

    /**
     * Date of the sign up yyyy-mm-dd
     */
    createdDate: string;


    /**
     * CHEWZIE, FEDELTA
     */
    deploymentType: string = "CHEWZIE";

    deploymentStatus: string;

}
